import React  from "react";
import CustomTable from "../../components/CustomTable";
import { reconciliationTableHeaders } from "../../constants/TableConstants";
import i18n from "../../constants/Strings";

const ReconciliationHistory = ({
  reconciliationHistory,
  downloadReconciliationfile
}) => {

  const text = {
    noHistory: i18n.t('reconciliation.noHistory'),
  }
    return (
        <> 
 
 {reconciliationHistory?.length ? (
                <CustomTable
                  data={reconciliationHistory}
                  headers={reconciliationTableHeaders}
                  handleDownload={downloadReconciliationfile}
                />
              ) : (
              <div className="d-flex justify-content-center mt-5">
                {text.noHistory}
              </div>
             )} 
              </>
    )
};

export default ReconciliationHistory;